import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BrandedHelpPage } from "@/features/helpcentre/BrandedHelpPage";

const search = z.object({ article: z.string().optional() });

/** The public help centre of a workspace, at /help/<workspace slug>, styled with that workspace's brand. `?article=<slug>`
 *  opens one published article (X3-14). */
export const Route = createFileRoute("/help/$slug")({
  validateSearch: search,
  component: HelpRoute,
});

function HelpRoute() {
  const { slug } = Route.useParams();
  const { article } = Route.useSearch();
  return <BrandedHelpPage slug={slug} article={article} />;
}
